import { render, staticRenderFns } from "./QuestionLayoutC.vue?vue&type=template&id=02c3638c&scoped=true&"
import script from "./QuestionLayoutC.vue?vue&type=script&lang=js&"
export * from "./QuestionLayoutC.vue?vue&type=script&lang=js&"
import style0 from "./QuestionLayoutC.vue?vue&type=style&index=0&id=02c3638c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c3638c",
  null
  
)

export default component.exports